import type { ReactNode } from 'react';
import VendorShell from './VendorShell';

/**
 * Vendor portal app shell — the §15z side-nav IA (header · side nav · content ·
 * footer). Kept as a thin alias so every route keeps importing `MainLayout`.
 */
export default function MainLayout({ children }: { children: ReactNode }) {
  return <VendorShell>{children}</VendorShell>;
}
